{
  "team.title": "الفريق",
  "team.subtitle": "كل أعضاء فريق 404 Creative وأدوارهم وما يمكنهم القيام به.",
  "team.tabs.label": "أقسام صفحة الفريق",
  "team.tabs.members": "الأعضاء",
  "team.tabs.departments": "الأقسام",
  "team.tabs.roles": "الأدوار",
  "team.tabs.activity": "سجل النشاط",
  "team.loadError": "تعذّر تحميل الفريق.",
  "team.loadMore": "عرض المزيد",
  "team.loadingMore": "جارٍ التحميل…",
  "team.search": "ابحث في الأعضاء",
  "team.filter.label": "التصفية حسب الحالة",
  "team.filter.all": "الكل",
  "team.filter.active": "نشط",
  "team.filter.invited": "مدعو",
  "team.filter.deactivated": "معطّل",
  "team.columns.member": "العضو",
  "team.columns.role": "الدور",
  "team.columns.department": "القسم",
  "team.columns.status": "الحالة",
  "team.columns.joined": "تاريخ الانضمام",
  "team.status.active": "نشط",
  "team.status.invited": "مدعو",
  "team.status.invitedExpires": "مدعو · تنتهي الدعوة {when}",
  "team.status.invitationExpired": "انتهت صلاحية الدعوة",
  "team.status.deactivated": "معطّل",
  "team.department.none": "بدون قسم",
  "team.empty.title": "لا يوجد أعضاء بعد",
  "team.empty.body": "ادعُ أول عضو لتبدأوا العمل معاً.",
  "team.noResults.title": "لا يوجد أعضاء مطابقون",
  "team.noResults.body": "جرّب اسماً أو بريداً أو حالة أخرى.",
  "team.noResults.clear": "مسح عوامل التصفية",
  "team.member.panel": "عضو في الفريق",
  "team.member.properties": "التفاصيل",
  "team.member.role": "الدور",
  "team.member.department": "القسم",
  "team.member.title": "المسمى الوظيفي",
  "team.member.titlePlaceholder": "أضف مسمى وظيفياً",
  "team.member.noTitle": "بدون مسمى وظيفي",
  "team.member.email": "البريد الإلكتروني",
  "team.member.joined": "تاريخ الانضمام",
  "team.member.invitedOn": "تاريخ الدعوة",
  "team.member.deactivatedOn": "تاريخ التعطيل",
  "team.member.invitedBy": "صاحب الدعوة",
  "team.member.unknownInviter": "عضو سابق",
  "team.member.expires": "تنتهي صلاحية الرابط",
  "team.member.notFound.title": "هذا العضو ليس في الفريق",
  "team.member.notFound.body": "ربما أُزيل من الفريق، أو أن الرابط غير مكتمل.",
  "team.member.roleChanged": "تم تغيير دور {name} إلى {role}.",
  "team.member.grantOwner.title": "منح {name} دور المالك؟",
  "team.member.grantOwner.body": "يملك المالك تحكماً كاملاً في 404 OS، بما في ذلك المالكون الآخرون. ولا يستطيع سحب هذا الدور لاحقاً إلا مالك.",
  "team.member.grantOwner.confirm": "منح دور المالك",
  "team.rules.viewOnly": "يغيّر هذا من يديرون الفريق فقط.",
  "team.rules.self": "لا يمكنك تغيير دورك أو تعطيل حسابك بنفسك.",
  "team.rules.ownerOnly": "لا يغيّر بيانات المالك إلا مالك آخر.",
  "team.rules.lastOwner": "هذا هو المالك النشط الوحيد. امنح شخصاً آخر دور المالك أولاً.",
  "team.rules.moreReach": "يستطيع هذا الشخص القيام بأشياء لا تستطيعها، لذا لا يمكنك تغيير بياناته.",
  "team.permissions.heading": "الصلاحيات",
  "team.permissions.hint": "ما يمنحه دور {role}، مع أي استثناءات لهذا الشخص. التغييرات تخصه وحده.",
  "team.permissions.ownerFixed": "يملك المالك كل الصلاحيات دائماً.",
  "team.permissions.self": "لا يمكنك تغيير صلاحياتك بنفسك.",
  "team.permissions.added": "مضافة",
  "team.permissions.removed": "محذوفة",
  "team.permissions.fixed": "لا يمنح هذه الصلاحية إلا دور المالك.",
  "team.permissions.ownerOnly": "المالك وحده يمنح صلاحية الاطلاع على الأمور المالية أو يسحبها.",
  "team.permissions.impliedBy": "تأتي مع {permission}.",
  "team.permissions.notHeld": "لا يمكنك منح صلاحيات لا تملكها أنت.",
  "team.permissions.reset": "العودة إلى صلاحيات الدور",
  "team.permissions.unsaved": "تغييرات غير محفوظة",
  "team.permissions.discard": "تجاهل",
  "team.permissions.save": "حفظ",
  "team.permissions.saving": "جارٍ الحفظ…",
  "team.permissions.saved": "تم حفظ صلاحيات {name}.",
  "team.permissions.loadError": "تعذّر تحميل الصلاحيات.",
  "team.permissions.confirm.title": "تغيير صلاحيات {name}؟",
  "team.permissions.confirm.adds": "يمنحه: {list}.",
  "team.permissions.confirm.removes": "يسحب منه: {list}.",
  "team.permissions.exceptions": "استثناءات من الدور: {added, plural, zero {لا إضافات} one {صلاحية واحدة مضافة} two {صلاحيتان مضافتان} few {# صلاحيات مضافة} many {# صلاحية مضافة} other {# صلاحية مضافة}}، {removed, plural, zero {لا حذف} one {صلاحية واحدة محذوفة} two {صلاحيتان محذوفتان} few {# صلاحيات محذوفة} many {# صلاحية محذوفة} other {# صلاحية محذوفة}}",
  "team.invitation.heading": "الدعوة",
  "team.invitation.link": "رابط الدعوة",
  "team.invitation.linkHidden": "حفاظاً على الأمان، يظهر رابط الدعوة مرة واحدة فقط. أعد إرسال الدعوة للحصول على رابط جديد، وسيتوقف الرابط القديم عن العمل.",
  "team.invitation.newLinkTitle": "الرابط الجديد جاهز",
  "team.invitation.newLinkBody": "انسخه وأرسله إلى {name}. الرابط السابق لم يعد يعمل.",
  "team.invitation.resend": "إعادة إرسال الدعوة",
  "team.invitation.resending": "جارٍ الإرسال…",
  "team.invitation.resent": "رابط دعوة جديد لـ{name} جاهز.",
  "team.invitation.revoke": "إلغاء الدعوة",
  "team.invitation.revoking": "جارٍ الإلغاء…",
  "team.invitation.revoked": "تم إلغاء دعوة {name}.",
  "team.invitation.revokeConfirm.title": "إلغاء دعوة {name}؟",
  "team.invitation.revokeConfirm.body": "سيتوقف الرابط عن العمل وسيُحذف {email} من قائمة الفريق. يمكنك دعوته مرة أخرى لاحقاً.",
  "team.account.heading": "الحساب",
  "team.account.deactivateHint": "يؤدي التعطيل إلى تسجيل خروجه من كل الأجهزة فوراً ومنعه من الدخول، مع بقاء عمله وسجله كما هو.",
  "team.account.reactivateHint": "هذا الحساب معطّل. أعد تفعيله ليتمكن صاحبه من تسجيل الدخول مجدداً.",
  "team.account.deactivate": "تعطيل الحساب",
  "team.account.deactivating": "جارٍ التعطيل…",
  "team.account.deactivated": "تم تعطيل حساب {name}.",
  "team.account.deactivateConfirm.title": "تعطيل حساب {name}؟",
  "team.account.deactivateConfirm.body": "سيُسجَّل خروجه من كل الأجهزة فوراً ولن يتمكن من تسجيل الدخول. تبقى مهامه وتعليقاته وسجله كما هي، ويمكنك إعادة تفعيل الحساب في أي وقت.",
  "team.account.reactivate": "إعادة التفعيل",
  "team.account.reactivating": "جارٍ إعادة التفعيل…",
  "team.account.reactivated": "تمت إعادة تفعيل حساب {name}.",
  "team.account.reactivateConfirm.title": "إعادة تفعيل حساب {name}؟",
  "team.account.reactivateConfirm.body": "سيتمكن من تسجيل الدخول بكلمة المرور الحالية، وبالدور نفسه الذي كان عليه.",
  "team.errors.lastOwner": "يجب أن يبقى في الفريق مالك نشط واحد على الأقل. امنح شخصاً آخر دور المالك أولاً.",
  "team.errors.self": "لا يمكنك تغيير دورك أو تعطيل حسابك بنفسك.",
  "team.errors.forbidden": "ليست لديك صلاحية للقيام بذلك. تم تحديث صلاحياتك.",
  "team.errors.conflict": "عدّل شخص آخر بيانات هذا العضو في هذه الأثناء، فتم تحديثها. حاول مرة أخرى.",
  "team.errors.stale": "تغيّرت هذه البيانات في هذه الأثناء، فتم تحديث الفريق.",
  "team.errors.invitationGone": "هذه الدعوة قُبلت أو أُلغيت بالفعل.",
  "team.invite.action": "دعوة عضو",
  "team.invite.title": "دعوة عضو إلى الفريق",
  "team.invite.description": "سيصله رابط يختار منه اسمه وكلمة مروره وينضم إلى 404 OS.",
  "team.invite.email": "البريد الإلكتروني للعمل",
  "team.invite.emailPlaceholder": "name@404creativee.com",
  "team.invite.name": "الاسم",
  "team.invite.nameHint": "اختياري، ويمكنه تعديله عند الانضمام.",
  "team.invite.role": "الدور",
  "team.invite.department": "القسم",
  "team.invite.submit": "إنشاء الدعوة",
  "team.invite.sending": "جارٍ الإنشاء…",
  "team.invite.errors.email": "اكتب بريداً إلكترونياً صحيحاً.",
  "team.invite.errors.emailTaken": "هذا البريد مستخدم بالفعل لعضو في الفريق.",
  "team.invite.errors.forbidden": "لا يدعو مالكاً آخر إلا مالك.",
  "team.invite.errors.nameLength": "استخدم ١٥٠ حرفاً أو أقل.",
  "team.invite.success.heading": "الدعوة جاهزة",
  "team.invite.success.title": "تم إنشاء الدعوة",
  "team.invite.success.body": "أرسل هذا الرابط إلى {email} لينضم إلى الفريق.",
  "team.invite.success.note": "أرسل هذا الرابط بنفسك. يعمل مرة واحدة وتنتهي صلاحيته بعد ٧ أيام.",
  "team.invite.another": "دعوة عضو آخر",
  "team.invite.done": "تم",
  "team.departments.title": "الأقسام",
  "team.departments.description": "نظّم الفريق حسب طبيعة العمل. يمكن حذف القسم عندما لا يبقى فيه أحد.",
  "team.departments.readOnly": "طريقة تنظيم الفريق. يدير الأقسام المالكون ومديرو النظام.",
  "team.departments.loadError": "تعذّر تحميل الأقسام.",
  "team.departments.memberCount": "{count, plural, zero {لا أعضاء} one {عضو واحد} two {عضوان} few {# أعضاء} many {# عضواً} other {# عضو}}",
  "team.departments.new": "قسم جديد",
  "team.departments.add": "إضافة",
  "team.departments.save": "حفظ",
  "team.departments.created": "تمت إضافة قسم {name}.",
  "team.departments.rename": "إعادة التسمية",
  "team.departments.renameLabel": "إعادة تسمية {name}",
  "team.departments.delete": "حذف {name}",
  "team.departments.deleteBlocked": "انقل كل الأعضاء من هذا القسم قبل حذفه.",
  "team.departments.deleting": "جارٍ الحذف…",
  "team.departments.deleted": "تم حذف قسم {name}.",
  "team.departments.deleteConfirm.title": "حذف قسم {name}؟",
  "team.departments.deleteConfirm.body": "لا يوجد أحد في هذا القسم، لذلك لن يتغير شيء آخر. سيبقى اسمه في سجل النشاط.",
  "team.departments.deleteConfirm.confirm": "حذف القسم",
  "team.departments.empty.title": "لا توجد أقسام بعد",
  "team.departments.empty.body": "تنظّم الأقسام الفريق، مثل التصميم أو التطوير.",
  "team.departments.errors.name": "اكتب اسماً.",
  "team.departments.errors.nameTaken": "يوجد قسم آخر بهذا الاسم.",
  "team.departments.errors.notEmpty": "انقل كل الأعضاء من هذا القسم قبل حذفه.",
  "team.activity.description": "كل تغيير على الفريق وقائمة العملاء، الأحدث أولاً.",
  "team.activity.loadError": "تعذّر تحميل سجل النشاط.",
  "team.activity.empty.title": "لا يوجد نشاط بعد",
  "team.activity.empty.body": "ستظهر هنا الدعوات وتغييرات الأدوار وتحديثات العملاء.",
  "team.activity.system": "404 OS",
  "team.activity.member.invited": "{actor} دعا {target} للانضمام بدور {role}",
  "team.activity.invitation.resent": "{actor} أرسل رابط دعوة جديداً إلى {target}",
  "team.activity.invitation.revoked": "{actor} ألغى دعوة {target}",
  "team.activity.invitation.accepted": "{target} قبل الدعوة وانضم إلى الفريق",
  "team.activity.member.roleChanged": "{actor} غيّر دور {target} من {from} إلى {to}",
  "team.activity.member.departmentChanged": "{actor} نقل {target} إلى قسم {to}",
  "team.activity.member.departmentCleared": "{actor} أخرج {target} من قسم {from}",
  "team.activity.member.titleChanged": "{actor} غيّر المسمى الوظيفي لـ{target} إلى {to}",
  "team.activity.member.titleCleared": "{actor} حذف المسمى الوظيفي لـ{target}",
  "team.activity.member.updated": "{actor} حدّث بيانات {target}",
  "team.activity.member.deactivated": "{actor} عطّل حساب {target}",
  "team.activity.member.reactivated": "{actor} أعاد تفعيل حساب {target}",
  "team.activity.member.permissionsGiven": "{actor} منح {target} {added}",
  "team.activity.member.permissionsTaken": "{actor} سحب {removed} من {target}",
  "team.activity.member.permissionsSwapped": "{actor} منح {target} {added} وسحب منه {removed}",
  "team.activity.member.permissionsReset": "{actor} أعاد {target} إلى ما يمنحه دوره",
  "team.activity.member.permissionsChanged": "{actor} غيّر صلاحيات {target}",
  "team.activity.department.created": "{actor} أنشأ قسم {target}",
  "team.activity.department.renamed": "{actor} غيّر اسم قسم {from} إلى {to}",
  "team.activity.department.deleted": "{actor} حذف قسم {target}",
  "team.activity.profile.updated": "{actor} حدّث ملفه الشخصي",
  "team.activity.email.changed": "{actor} غيّر بريده الإلكتروني",
  "team.activity.password.changed": "{actor} غيّر كلمة المرور الخاصة به",
  "team.activity.password.reset": "{actor} أعاد تعيين كلمة المرور الخاصة به",
  "team.activity.client.created": "{actor} أضاف العميل {target}",
  "team.activity.client.updated": "{actor} حدّث بيانات العميل {target}",
  "team.activity.client.archived": "{actor} أرشف العميل {target}",
  "team.activity.client.restored": "{actor} استعاد العميل {target}",
  "team.activity.contact.added": "{actor} أضاف {contact} إلى جهات اتصال {target}",
  "team.activity.contact.updated": "{actor} حدّث بيانات {contact} في جهات اتصال {target}",
  "team.activity.contact.removed": "{actor} حذف {contact} من جهات اتصال {target}",
  "team.activity.unknown": "{actor} أجرى تغييراً ({action})",
  "roles.title": "الأدوار والصلاحيات",
  "roles.explainer": "لكل شخص دور واحد، والدور يحدد ما يراه وما يستطيع فعله في 404 OS. وداخل كل مشروع يكون الشخص أيضاً قائد المشروع أو مساهماً فيه أو متابعاً له.",
  "roles.loadError": "تعذّر تحميل الأدوار.",
  "roles.yourRole": "دورك",
  "roles.noPermissions": "بلا صلاحيات على مستوى الوكالة: يرى المشاريع التي أُضيف إليها فقط.",
  "roles.matrix.caption": "ما يستطيع كل دور فعله",
  "roles.matrix.permission": "الصلاحية",
  "roles.matrix.included": "متاحة",
  "roles.matrix.notIncluded": "غير متاحة",
  "roles.group.team": "الفريق",
  "roles.group.projects": "المشاريع",
  "roles.group.tasks": "المهام",
  "roles.group.clients": "العملاء",
  "roles.group.time": "الوقت",
  "roles.group.leads": "العملاء المحتملون",
  "roles.group.billing": "الفواتير",
  "roles.group.tickets": "الدعم",
  "roles.owner.summary": "تحكم كامل في 404 OS، بما في ذلك المالكون الآخرون.",
  "roles.admin.summary": "يدير الفريق والعملاء وكل المشاريع.",
  "roles.pm.summary": "ينشئ المشاريع ويديرها، ويدير بيانات العملاء.",
  "roles.finance.summary": "يتابع كل المشاريع والعملاء دون تعديل العمل.",
  "roles.member.summary": "يرى العملاء، ويعمل في المشاريع التي ينضم إليها.",
  "roles.contractor.summary": "يرى المشاريع التي أُضيف إليها فقط.",
  "permission.team.view.label": "عرض الفريق",
  "permission.team.view.description": "فتح قائمة الفريق والأقسام والأدوار.",
  "permission.team.manage.label": "إدارة الفريق",
  "permission.team.manage.description": "دعوة الأعضاء وتغيير الأدوار وتعطيل الحسابات.",
  "permission.team.manage_owners.label": "إدارة المالكين",
  "permission.team.manage_owners.description": "منح دور المالك، أو تغيير دور مالك أو حسابه.",
  "permission.departments.manage.label": "إدارة الأقسام",
  "permission.departments.manage.description": "إضافة الأقسام وإعادة تسميتها وحذفها.",
  "permission.audit.view.label": "عرض سجل النشاط",
  "permission.audit.view.description": "الاطلاع على سجل التغييرات على الفريق والعملاء.",
  "permission.projects.create.label": "إنشاء المشاريع",
  "permission.projects.create.description": "بدء مشاريع جديدة وقيادتها.",
  "permission.projects.view_all.label": "عرض كل المشاريع",
  "permission.projects.view_all.description": "فتح أي مشروع، لا مشاريعه فقط.",
  "permission.projects.manage_all.label": "إدارة كل المشاريع",
  "permission.projects.manage_all.description": "تعديل بيانات أي مشروع وأعضائه ومهامه.",
  "permission.clients.view.label": "عرض العملاء",
  "permission.clients.view.description": "فتح قائمة العملاء وجهات الاتصال ومشاريعهم.",
  "permission.clients.manage.label": "إدارة العملاء",
  "permission.clients.manage.description": "إضافة العملاء وجهات الاتصال وتعديلها، وأرشفة العملاء.",
  "permission.time.view_all.label": "رؤية وقت الجميع",
  "permission.time.view_all.description": "فتح الجدول الزمني لأي شخص وتقارير الوقت على مستوى الوكالة.",
  "permission.leads.manage.label": "إدارة العملاء المحتملين",
  "permission.leads.manage.description": "مزامنة طلبات الموقع، والرد عليها وتأهيلها، وتحويلها إلى عملاء ومشروعات.",
  "permission.billing.view.label": "رؤية الفواتير",
  "permission.billing.view.description": "فتح العروض والفواتير والمدفوعات والمصروفات وتقارير الأموال.",
  "permission.billing.manage.label": "إدارة الفواتير",
  "permission.billing.manage.description": "إرسال العروض وإصدار الفواتير المبدئية وطلبات الدفع وتسجيل المدفوعات وإشعارات الدائن والمصروفات.",
  "permission.tickets.view.label": "رؤية الدعم",
  "permission.tickets.view.description": "فتح صندوق دعم العملاء وقراءة المحادثة.",
  "permission.tickets.manage.label": "العمل على الدعم",
  "permission.tickets.manage.description": "استلام الطلب والرد وإنهاؤه وإعادة تعيينه وتحويله إلى مهمة.",
  "invitation.documentTitle": "الانضمام إلى الفريق",
  "invitation.title": "أنت مدعو للانضمام إلى 404 OS",
  "invitation.subtitle": "دعاك {inviter} إلى فريق 404 Creative. راجع اسمك واختر كلمة مرور.",
  "invitation.subtitleNoInviter": "تمت دعوتك إلى فريق 404 Creative. راجع اسمك واختر كلمة مرور.",
  "invitation.email": "البريد الإلكتروني",
  "invitation.role": "الدور",
  "invitation.invitedBy": "صاحب الدعوة",
  "invitation.name": "اسمك",
  "invitation.password": "كلمة المرور",
  "invitation.passwordHint": "{count, plural, zero {# حرف على الأقل} one {حرف واحد على الأقل} two {حرفان على الأقل} few {# أحرف على الأقل} many {# حرفاً على الأقل} other {# حرف على الأقل}}",
  "invitation.join": "الانضمام إلى 404 OS",
  "invitation.joining": "جارٍ الانضمام…",
  "invitation.welcome": "أهلاً بك في 404 OS يا {name}.",
  "invitation.errors.name": "اكتب اسمك.",
  "invitation.errors.nameLength": "استخدم ١٥٠ حرفاً أو أقل.",
  "invitation.errors.password": "استخدم ١٠ أحرف على الأقل.",
  "invitation.loadError": "تعذّر فتح هذه الدعوة.",
  "invitation.invalid.title": "هذه الدعوة لم تعد صالحة",
  "invitation.invalid.body": "ربما استُخدمت من قبل أو أُلغيت. اطلب رابطاً جديداً ممن دعاك.",
  "invitation.expired.title": "انتهت صلاحية هذه الدعوة",
  "invitation.expired.body": "اطلب رابطاً جديداً ممن دعاك.",
  "invitation.goToSignIn": "الذهاب إلى تسجيل الدخول",
  "profile.title": "الملف الشخصي والإعدادات",
  "profile.subtitle": "بياناتك ومظهر التطبيق ولغتك وبريدك وكلمة المرور.",
  "profile.section.profile": "الملف الشخصي",
  "profile.section.profileHint": "كيف تظهر لأعضاء الفريق، واللغة التي يخاطبك بها 404 OS.",
  "profile.section.password": "كلمة المرور",
  "profile.section.passwordHint": "تغييرها يسجّل خروجك من كل أجهزتك الأخرى.",
  "profile.section.account": "الحساب",
  "profile.section.accountHint": "يحددها من يديرون الفريق.",
  "profile.name": "الاسم",
  "profile.jobTitle": "المسمى الوظيفي",
  "profile.jobTitleHint": "يحدده المسؤول من صفحة الفريق.",
  "profile.jobTitleEmpty": "لم يُحدَّد بعد",
  "profile.picture.upload": "رفع صورة",
  "profile.picture.change": "تغيير الصورة",
  "profile.picture.uploading": "جارٍ الرفع…",
  "profile.picture.remove": "إزالة",
  "profile.picture.hint": "صورة واضحة لوجهك، وسنقصّها على شكل مربع.",
  "profile.picture.saved": "تم تحديث الصورة",
  "profile.picture.removed": "تمت إزالة الصورة",
  "profile.picture.errors.type": "اختر صورة PNG أو JPEG أو WebP.",
  "profile.picture.errors.tooLarge": "الصورة كبيرة جدًا، جرّب صورة أصغر.",
  "profile.picture.errors.generic": "تعذّر حفظ الصورة، حاول مرة أخرى.",
  "profile.language": "اللغة",
  "profile.language.ar": "العربية",
  "profile.language.ar.hint": "من اليمين لليسار، بالأرقام العربية",
  "profile.language.en": "English",
  "profile.language.en.hint": "من اليسار لليمين، بالأرقام اللاتينية",
  "profile.languageNote": "تنتقل لغتك معك إلى كل جهاز تسجّل الدخول منه.",
  "profile.save": "حفظ التغييرات",
  "profile.saving": "جارٍ الحفظ…",
  "profile.saved": "تم حفظ ملفك الشخصي.",
  "profile.errors.name": "اكتب اسمك.",
  "profile.errors.nameLength": "استخدم ١٥٠ حرفاً أو أقل.",
  "profile.password.current": "كلمة المرور الحالية",
  "profile.password.new": "كلمة المرور الجديدة",
  "profile.password.confirm": "تأكيد كلمة المرور الجديدة",
  "profile.password.hint": "{count, plural, zero {# حرف على الأقل} one {حرف واحد على الأقل} two {حرفان على الأقل} few {# أحرف على الأقل} many {# حرفاً على الأقل} other {# حرف على الأقل}}",
  "profile.password.note": "سيتم تسجيل خروجك من أجهزتك الأخرى.",
  "profile.password.submit": "تغيير كلمة المرور",
  "profile.password.changing": "جارٍ التغيير…",
  "profile.password.changed": "تم تغيير كلمة المرور، وتسجيل خروجك من أجهزتك الأخرى.",
  "profile.password.errors.current": "اكتب كلمة المرور الحالية.",
  "profile.password.errors.wrong": "هذه ليست كلمة المرور الحالية.",
  "profile.password.errors.length": "استخدم ١٠ أحرف على الأقل.",
  "profile.password.errors.mismatch": "كلمتا المرور غير متطابقتين.",
  "profile.section.email": "البريد الإلكتروني",
  "profile.section.emailHint": "العنوان الذي تسجّل الدخول به وتصلك عليه رسائل 404 OS.",
  "profile.email.current": "تسجّل الدخول حاليًا بـ",
  "profile.email.new": "البريد الجديد",
  "profile.email.password": "كلمة المرور الحالية",
  "profile.email.note": "كلمة المرور تبقى كما هي.",
  "profile.email.submit": "تغيير البريد",
  "profile.email.changing": "جارٍ التغيير…",
  "profile.email.changed": "تم تغيير البريد. سجّل الدخول من الآن بـ {email}.",
  "profile.email.errors.invalid": "اكتب بريدًا إلكترونيًا صحيحًا.",
  "profile.email.errors.password": "اكتب كلمة المرور الحالية.",
  "profile.email.errors.wrong": "هذه ليست كلمة المرور الحالية.",
  "profile.email.errors.taken": "هذا البريد مستخدم بالفعل في 404 OS.",
  "profile.account.email": "البريد الإلكتروني",
  "profile.account.role": "الدور",
  "profile.account.department": "القسم",
  "profile.account.memberSince": "عضو منذ",
  "profile.account.permissions": "ما يتيحه لك دورك",
  "profile.account.managedBy": "لتغيير دورك أو قسمك، تواصل مع مدير النظام أو المالك.",
  "clients.subtitle": "الشركات التي نعمل معها، والأشخاص الذين نتواصل معهم فيها.",
  "clients.new": "عميل جديد",
  "clients.loadError": "تعذّر تحميل العملاء.",
  "clients.loadMore": "عرض المزيد",
  "clients.loadingMore": "جارٍ التحميل…",
  "clients.loading": "جارٍ التحميل…",
  "clients.search": "ابحث في العملاء وجهات الاتصال",
  "clients.filter.label": "التصفية حسب الحالة",
  "clients.filter.active": "نشط",
  "clients.filter.archived": "مؤرشف",
  "clients.filter.all": "الكل",
  "clients.status.active": "نشط",
  "clients.status.archived": "مؤرشف",
  "clients.columns.client": "العميل",
  "clients.columns.location": "الدولة",
  "clients.columns.contact": "جهة الاتصال الرئيسية",
  "clients.columns.contacts": "جهات الاتصال",
  "clients.columns.created": "تاريخ الإضافة",
  "clients.noContact": "لا توجد جهة اتصال بعد",
  "clients.noCountry": "غير محددة",
  "clients.empty.title": "لا يوجد عملاء بعد",
  "clients.empty.body": "أضف أول عميل لتربط به المشاريع وتحفظ جهات اتصاله في مكان واحد.",
  "clients.empty.bodyReadOnly": "سيظهر هنا العملاء الذين يضيفهم مديرو المشاريع.",
  "clients.noResults.title": "لا يوجد عملاء مطابقون",
  "clients.noResults.body": "جرّب اسماً أو جهة اتصال أو حالة أخرى.",
  "clients.noResults.clear": "مسح عوامل التصفية",
  "clients.notFound.title": "العميل غير موجود",
  "clients.notFound.body": "ربما حُذف، أو أن الرابط غير مكتمل.",
  "clients.detailLoadError": "تعذّر تحميل بيانات هذا العميل.",
  "clients.backToList": "الذهاب إلى العملاء",
  "clients.tabs.label": "أقسام صفحة العميل",
  "clients.tabs.overview": "نظرة عامة",
  "clients.tabs.projects": "المشاريع",
  "clients.prefers.ar": "يفضّل العربية",
  "clients.prefers.en": "يفضّل الإنجليزية",
  "clients.language.ar": "العربية",
  "clients.language.ar.hint": "المراسلات والمستندات بالعربية",
  "clients.language.en": "الإنجليزية",
  "clients.language.en.hint": "المراسلات والمستندات بالإنجليزية",
  "clients.edit": "تعديل",
  "clients.archive": "أرشفة",
  "clients.archiving": "جارٍ الأرشفة…",
  "clients.archived": "تمت أرشفة {name}.",
  "clients.archiveConfirm.title": "أرشفة {name}؟",
  "clients.archiveConfirm.body": "سيخرج من قائمة العملاء النشطين ولن يظهر عند إنشاء مشاريع جديدة. تبقى مشاريعه وجهات اتصاله وسجله كما هي، ويمكنك استعادته في أي وقت.",
  "clients.restore": "استعادة",
  "clients.restoring": "جارٍ الاستعادة…",
  "clients.restored": "عاد {name} إلى العملاء النشطين.",
  "clients.restoreConfirm.title": "استعادة {name}؟",
  "clients.restoreConfirm.body": "سيعود إلى قائمة العملاء النشطين ويمكن ربطه بالمشاريع من جديد.",
  "clients.archivedNotice.title": "هذا العميل مؤرشف",
  "clients.archivedNotice.body": "استعِده لتعديل بياناته أو جهات اتصاله.",
  "clients.archivedNotice.bodyReadOnly": "بياناته محفوظة للرجوع إليها.",
  "clients.details.title": "البيانات",
  "clients.details.legalName": "الاسم القانوني",
  "clients.details.country": "الدولة",
  "clients.details.currency": "العملة",
  "clients.details.language": "اللغة",
  "clients.details.website": "الموقع الإلكتروني",
  "clients.details.created": "تاريخ الإضافة",
  "clients.details.notes": "ملاحظات",
  "clients.details.none": "غير محدد",
  "clients.errors.nameTaken": "يوجد عميل نشط بهذا الاسم.",
  "clients.errors.archived": "هذا العميل مؤرشف. استعِده أولاً.",
  "clients.errors.conflict": "عدّل شخص آخر بيانات هذا العميل في هذه الأثناء، فتم تحديثها. حاول مرة أخرى.",
  "clients.errors.forbidden": "ليست لديك صلاحية تعديل بيانات العملاء.",
  "clients.errors.contactGone": "جهة الاتصال هذه لم تعد موجودة.",
  "clients.form.newTitle": "عميل جديد",
  "clients.form.newDescription": "شركة نعمل لصالحها. يمكنك بعد ذلك إضافة الأشخاص الذين نتواصل معهم فيها.",
  "clients.form.editTitle": "تعديل بيانات العميل",
  "clients.form.name": "الاسم",
  "clients.form.namePlaceholder": "بيت القهوة",
  "clients.form.legalName": "الاسم القانوني",
  "clients.form.optional": "اختياري",
  "clients.form.country": "الدولة",
  "clients.form.otherCountry": "دولة أخرى…",
  "clients.form.countryCode": "رمز الدولة",
  "clients.form.countryCodeHint": "حرفان باللاتينية، مثل SA أو QA أو GB.",
  "clients.form.currency": "العملة",
  "clients.form.currencyOption": "{code} · {name}",
  "clients.form.language": "اللغة المفضلة",
  "clients.form.website": "الموقع الإلكتروني",
  "clients.form.websitePlaceholder": "example.com",
  "clients.form.notes": "ملاحظات",
  "clients.form.notesPlaceholder": "طريقة عملهم، ومن يتخذ القرار، وأي شيء يجب أن يعرفه الفريق.",
  "clients.form.create": "إنشاء العميل",
  "clients.form.save": "حفظ التغييرات",
  "clients.form.saving": "جارٍ الحفظ…",
  "clients.form.created": "تمت إضافة {name}.",
  "clients.form.saved": "تم حفظ بيانات العميل.",
  "clients.form.errors.name": "استخدم حرفين على الأقل.",
  "clients.form.errors.tooLong": "هذا النص طويل جداً.",
  "clients.form.errors.country": "استخدم رمز دولة من حرفين، مثل SA.",
  "clients.projects.project": "المشروع",
  "clients.projects.status": "الحالة",
  "clients.projects.lead": "قائد المشروع",
  "clients.projects.progress": "الإنجاز",
  "clients.projects.noLead": "بلا قائد",
  "clients.projects.loadError": "تعذّر تحميل مشاريع هذا العميل.",
  "clients.projects.empty.title": "لا توجد مشاريع بعد",
  "clients.projects.empty.body": "ستظهر هنا مشاريع هذا العميل.",
  "contact.title": "جهات الاتصال",
  "contact.add": "إضافة جهة اتصال",
  "contact.added": "تمت إضافة {name}.",
  "contact.saved": "تم حفظ بيانات {name}.",
  "contact.edit": "تعديل",
  "contact.editLabel": "تعديل {name}",
  "contact.remove": "حذف",
  "contact.removeLabel": "حذف {name}",
  "contact.removing": "جارٍ الحذف…",
  "contact.removed": "تم حذف {name}.",
  "contact.removeConfirm.title": "حذف {name}؟",
  "contact.removeConfirm.body": "سيُحذف من جهات اتصال هذا العميل، ولا يمكن التراجع عن ذلك.",
  "contact.removeConfirm.bodyPrimary": "هذه جهة الاتصال الرئيسية، لذلك ستصبح جهة الاتصال التالية هي الرئيسية. لا يمكن التراجع عن ذلك.",
  "contact.primary": "رئيسية",
  "contact.noMethods": "لا يوجد بريد أو هاتف بعد",
  "contact.whatsappWith": "مراسلة {name} عبر واتساب",
  "contact.empty.title": "لا توجد جهات اتصال بعد",
  "contact.empty.body": "أضف الأشخاص الذين نتواصل معهم لدى هذا العميل. أول جهة اتصال تصبح الرئيسية.",
  "contact.form.newTitle": "إضافة جهة اتصال",
  "contact.form.newDescription": "شخص نتواصل معه لدى {client}.",
  "contact.form.editTitle": "تعديل جهة الاتصال",
  "contact.form.name": "الاسم",
  "contact.form.title": "المسمى الوظيفي",
  "contact.form.titlePlaceholder": "مدير التسويق",
  "contact.form.email": "البريد الإلكتروني",
  "contact.form.phone": "الهاتف",
  "contact.form.whatsapp": "واتساب",
  "contact.form.phoneHint": "اكتب الرقم برمز الدولة. الرقم بدون رمز يُعتبر رقماً في {country}.",
  "contact.form.language": "اللغة المفضلة",
  "contact.form.primary": "جهة الاتصال الرئيسية",
  "contact.form.primaryHint": "أول من نتواصل معه لدى هذا العميل. لا يمكن أن تكون إلا جهة اتصال رئيسية واحدة.",
  "contact.form.notes": "ملاحظات",
  "contact.form.add": "إضافة جهة الاتصال",
  "contact.form.save": "حفظ التغييرات",
  "contact.form.saving": "جارٍ الحفظ…",
  "contact.form.errors.name": "اكتب اسماً.",
  "contact.form.errors.email": "اكتب بريداً إلكترونياً صحيحاً.",
  "contact.form.errors.phone": "هذا الرقم طويل جداً.",
  "contact.form.errors.phoneInvalid": "اكتب رقم الهاتف برمز الدولة، مثل ‎+20 100 123 4567.",
  "contact.form.errors.tooLong": "هذا النص طويل جداً.",
  "profile.section.appearance": "المظهر",
  "profile.section.appearanceHint": "فاتح أو داكن أو حسب إعداد هذا الجهاز.",
  "profile.appearance.note": "يُطبَّق فورًا ويُحفظ على هذا الجهاز.",
  "team.tiles.active": "أعضاء نشطون",
  "team.tiles.deactivated": "{count, plural, zero {لا حسابات موقوفة} one {حساب موقوف واحد} two {حسابان موقوفان} few {# حسابات موقوفة} many {# حسابًا موقوفًا} other {# حساب موقوف}}",
  "team.tiles.invited": "دعوات معلّقة",
  "team.tiles.invitedCaption": "بانتظار الانضمام",
  "team.tiles.unplaced": "{count, plural, zero {الجميع في أقسام} one {عضو واحد بلا قسم} two {عضوان بلا قسم} few {# أعضاء بلا قسم} many {# عضوًا بلا قسم} other {# عضو بلا قسم}}",
  "team.tiles.roles": "الأدوار المستخدمة",
  "team.tiles.rolesCaption": "اطّلع على صلاحيات كل دور",
  "team.departments.split.title": "توزيع الفريق",
  "team.departments.split.body": "الأعضاء النشطون والمدعوون في كل قسم",
  "clients.tiles.active": "عملاء نشطون",
  "clients.tiles.archived": "{count, plural, zero {لا عملاء مؤرشفين} one {عميل مؤرشف واحد} two {عميلان مؤرشفان} few {# عملاء مؤرشفين} many {# عميلًا مؤرشفًا} other {# عميل مؤرشف}}",
  "clients.tiles.projects": "مشاريع جارية",
  "clients.tiles.withWork": "{count, plural, zero {لا عمل جارٍ لأي عميل} one {لعميل واحد} two {لعميلين} few {لـ# عملاء} many {لـ# عميلًا} other {لـ# عميل}}",
  "clients.tiles.contacts": "جهات الاتصال",
  "clients.tiles.contactsCaption": "الأشخاص الذين تتواصل معهم",
  "clients.tiles.countries": "الدول",
  "clients.tiles.countriesCaption": "أماكن عملائك",
  "clients.columns.projects": "المشاريع",
  "clients.projects.none": "لا مشاريع",
  "clients.projects.more": "+{count}",
  "clients.work.title": "العمل لهذا العميل",
  "clients.work.all": "كل المشاريع",
  "clients.work.running": "مشاريع جارية",
  "clients.work.openTasks": "مهام مفتوحة",
  "clients.work.overdue": "متأخرة",
  "clients.work.noneRunning": "لا عمل جارٍ لهذا العميل الآن.",
  "team.invite.success.emailedTitle": "تم إرسال الدعوة",
  "team.invite.success.emailedBody": "أرسلنا الدعوة إلى {email} بالبريد. ويمكنك أيضًا نسخ الرابط بالأسفل وإرساله على واتساب.",
  "team.invite.success.emailedNote": "يعمل الرابط مرة واحدة وتنتهي صلاحيته بعد ٧ أيام.",
  "team.invitation.resentEmailed": "أرسلنا دعوة جديدة إلى {name} بالبريد.",
  "roles.hr.summary": "تدير شؤون الفريق: ملفات الموظفين والحضور والإجازات والمرتبات والتقييم والتوظيف.",
  "roles.group.hr": "الموظفون",
  "roles.group.payroll": "المرتبات",
  "roles.group.performance": "الأداء",
  "roles.group.recruitment": "التوظيف",
  "permission.hr.view.label": "رؤية ملفات الموظفين",
  "permission.hr.view.description": "فتح ملف كل موظف وحضوره وإجازاته، من غير المرتبات.",
  "permission.hr.manage.label": "إدارة ملفات الموظفين",
  "permission.hr.manage.description": "تعديل الملفات وقراءة البيانات المحمية وتصحيح الحضور والبت في الطلبات كموارد بشرية.",
  "permission.payroll.view.label": "رؤية المرتبات",
  "permission.payroll.view.description": "رؤية المرتبات وشهور الصرف وقسائم كل الموظفين.",
  "permission.payroll.manage.label": "تشغيل المرتبات",
  "permission.payroll.manage.description": "تغيير المرتبات وإضافة المكافآت والخصومات وتشغيل الشهر وقفله وصرفه.",
  "permission.performance.manage.label": "إدارة التقييمات",
  "permission.performance.manage.description": "بدء دورات التقييم ومعايرة الدرجات وقراءة كل التقييمات.",
  "permission.recruitment.view.label": "رؤية التوظيف",
  "permission.recruitment.view.description": "فتح الوظائف المتاحة والمتقدمين.",
  "permission.recruitment.manage.label": "إدارة التوظيف",
  "permission.recruitment.manage.description": "نشر الوظائف وتحريك المتقدمين وتحديد المقابلات وإرسال العروض.",
  "permission.tasks.create.label": "إنشاء المهام",
  "permission.tasks.create.description": "إضافة المهام والمهام الفرعية، وتحويل التذاكر إلى مهام، وجعل المهام تتكرر."
}
